import sendToServer from './send-to-server';
const Expertise = {
  init() {
    if ($('.expertise').length !== 1) return;

    $('#video-popper').click(()=> {
      $('#pop-video').slideDown(300, ()=>{
        $('#pop-video video')[0].play();
      });
    });
    $('#feedback-prompt').click(this.handleFeedbackLauncherClick);
    $('#feedback-popup .close-button').click(this.handleCloseButtonClick);
    $('#feedback-body').keyup(this.handleFeedbackTyping);
    $('#feedback-submit-button').click(this.handleFeedbackSubmitClick.bind(this));
  },

  handleFeedbackLauncherClick() {
    $('#feedback-popup').fadeIn();
  },

  handleCloseButtonClick() {
    $('#feedback-popup').fadeOut();
  },

  handleFeedbackTyping() {
    if ($('#feedback-body').val().length > 0) {
      $('#feedback-submit-button').prop('disabled', false);
    } else {
      $('#feedback-submit-button').prop('disabled', true);
    }
  },

  handleFeedbackSubmitClick() {
    sendToServer('/api/v2/messages',
                 {body: $('#feedback-body').val()},
                 this.brieflyShowFeedbackSuccessMessage);
    $('#feedback-popup').fadeOut();
    $('#feedback-body').val('');
  },

  brieflyShowFeedbackSuccessMessage() {
    window.setTimeout(()=>{ $('#feedback-success-message').fadeOut() }, 3000)
    $('#feedback-success-message').fadeIn();
  }


}

$(document).ready(()=> {
  Expertise.init();
});
